import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    data: [],
};

const slotFreeSpinReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.value,
    }),
    [type.DROPDOWN]: (state, action) => ({
        ...state,
        dropDown: action.value,
    }),
    [type.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
    [type.SHOW]: (state, action) => ({
        ...state,
        show: action.value
    }),
    [type.GET_FREE_SPIN_MEMBER]: (state, action) => ({
        ...state,
        member: action.value,
    }),
    [type.ADD_FREE_SPIN_MEMBER]: (state, action) => ({
        ...state,
        memberStore: action.value,
    }),
});

export default slotFreeSpinReducer;